//----------------------------------------------------Library
import React, { useState } from "react";
import { Button, Checkbox, CircularProgress, FormControlLabel, Grid, Link, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
//----------------------------------------------------redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AccountActions from "../Actions/AccountActions";
import * as ProcessActions from "../Actions/ProcessActions";
//----------------------------------------------------Utils
import { convertTVIUserToTVTSC } from "../Utils";

import { PLATFORM_REDIRECT_URL } from "../Constants";

const styles = (theme) => ({
  nextBtn: {
    margin: "10px 0 10px 0",
    height: "3rem",
    backgroundColor: '#155E98',
  },
});

const StepFour = (props) => {

  const [agreedOne, setAgreedOne] = useState(false);
  const [agreedTwo, setAgreedTwo] = useState(false);
  const [agreedThree, setAgreedThree] = useState(false);
  const [agreedFour, setAgreedFour] = useState(false);

  const confirmConvert = async () => {
    const { userAccount, actions, openSnackbar } = props;
    const { username, fullName, email } = userAccount;
    if (!username || !fullName || !email) {
      actions.setStep(1);
    }

    if (!agreedOne || !agreedTwo || !agreedThree || !agreedFour) {
      openSnackbar(null);
      openSnackbar({
        type: "error",
        open: true,
        message: 'Please accept All Terms & Conditions',
        duration: 4000
      });
      return;
    } else {
      actions.setLoading(true);

      const data = { username, fullName, email };
      const result = await convertTVIUserToTVTSC(data);
  
      if (result.ok) {
        actions.setLoading(false);
        openSnackbar(null);
        openSnackbar({
          type: "success",
          open: true,
          message: 'Successfully opened a live account. Redirecting... Please wait',
          duration: 4000
        });
        setTimeout(() => {
          //window.location.href = `${PLATFORM_REDIRECT_URL}/login`;
          window.top.location.href = `${PLATFORM_REDIRECT_URL}/login`;
        }, 3000);
  
      } else {
        actions.setLoading(false);
        openSnackbar(null);
        openSnackbar({
          type: "error",
          open: true,
          message: result.msg && result.msg.message ? result.msg.message : 'Something went wrong. Please try again',
          duration: 4000
        });
      }
    }



    // if (isObject(userAccount))
    //window.location.href = `${PLATFORM_REDIRECT_URL}/login`
  }

  if (props.userAccount && props.userAccount.source === 'TVTSC') {
    return (
      <Grid container>
        <Grid item xs={12} style={{ paddingBottom: "6px", marginBottom: "5px" }}>
          <Typography variant="h4" gutterBottom><strong>Term and Conditions</strong></Typography>
        </Grid>
        <Grid item xs={12}>
          Already TVTSC user, redirect to platform
        </Grid>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={()=>{window.top.location.href = `${PLATFORM_REDIRECT_URL}/login`;}}
          className={props.classes.nextBtn}
        >
          {props.loading ? <CircularProgress size={20} color='inherit' >&nbsp;Please Wait...</CircularProgress> : <Typography variant="h5">Redirect</Typography>}
        </Button>
      </Grid>
    )
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ paddingBottom: "6px", marginBottom: "5px" }}>
        <Typography variant="h4" gutterBottom><strong>Term and Conditions</strong></Typography>
      </Grid>
      <Grid item xs={12} style={{ textAlign: 'left' }}>
        <p>You are applying for a CFD account. The purpose of the CFD account is for trading purposes only.</p>
        <p>CFD accounts are provided by Trade View Ltd which is a trading name of Trade View Technologies Ltd and 
          is a Securities Dealer registered in Seychelles with registration number 8431779-1 and authorised by the 
          Financial Services Authority (FSA) with licence number SD125
        </p>

      </Grid>
      <Grid item xs={12} style={{ textAlign: "left" }}>
        <FormControlLabel
          control={<Checkbox color="primary" checked={agreedOne} onChange={({ target }) => setAgreedOne(target.checked)} name="agreed" />}
          label={<Typography variant="body2">I understand the nature and risks associated with trading CFDs.</Typography>}
        />
        <FormControlLabel
          control={<Checkbox color="primary" checked={agreedTwo} onChange={({ target }) => setAgreedTwo(target.checked)} name="agreed" />}
          label={<Typography variant="body2">I hereby confirm that I have read, understand and agree to be bound by the terms of these.<Link href=" https://tradeview.tech/legal-documents/" target="_blank">Legal Documents</Link>.</Typography>}
        />
        <FormControlLabel
          control={<Checkbox color="primary" checked={agreedThree} onChange={({ target }) => setAgreedThree(target.checked)} name="agreedThree" />}
          label={<Typography variant="body2">I consent to receive emails from Trade View Group of companies about trading ideas, products and services. </Typography>}
        />
        <FormControlLabel
          control={<Checkbox color="primary" checked={agreedFour} onChange={({ target }) => setAgreedFour(target.checked)} name="agreedFour" />}
          label={<Typography variant="body2">I certify that the information given by me in this form is true and correct. </Typography>}
        />
      </Grid>
      
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={confirmConvert}
        className={props.classes.nextBtn}
      >
        {props.loading ? <CircularProgress size={20} color='inherit' >&nbsp;Please Wait...</CircularProgress> : <Typography variant="h5">Create Account</Typography>}
      </Button>
    </Grid>
  )
}

const mapStateToProps = ({ process, accountReducer }) => ({
  loading: process.loading,
  userAccount: accountReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ProcessActions, dispatch),
  accountActions: bindActionCreators(AccountActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StepFour));